import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BoldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Bold",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.74 30h8.82A8.284 8.284 0 0 0 23 15.47a8.3 8.3 0 0 0 1.82-5.19c0-4.57-3.71-8.28-8.28-8.28H8.75a2.59 2.59 0 0 0-2.59 2.59v22.82A2.59 2.59 0 0 0 8.75 30Zm8.77-5.18h-6.18v-6.23h6.37c1.72 0 3.11 1.39 3.11 3.11s-1.39 3.11-3.11 3.11h-.2ZM11.33 7.18h5.37c1.72 0 3.11 1.39 3.11 3.11s-1.39 3.11-3.11 3.11h-5.38V7.18Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.25 28H9c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h8.25c3.08 0 5.58 2.5 5.58 5.58 0 1.79-.85 3.39-2.17 4.42 2.38 1.24 4 3.72 4 6.58 0 4.09-3.33 7.42-7.42 7.42ZM10 26h7.25c2.99 0 5.42-2.43 5.42-5.42s-2.43-5.42-5.42-5.42H10v10.83Zm0-12.83h7.25c1.98 0 3.58-1.61 3.58-3.58s-1.61-3.58-3.58-3.58H10v7.17Z"
      })
    })
  }));
};